import { render, staticRenderFns } from "./commentsList.vue?vue&type=template&id=f28d92ee"
import script from "./commentsList.vue?vue&type=script&lang=js"
export * from "./commentsList.vue?vue&type=script&lang=js"
import style0 from "./commentsList.vue?vue&type=style&index=0&id=f28d92ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports